import type { Product } from '../../../shared/types';

type SeedBook = {
  id: string;
  title: string;
  description: string;
  author: string;
  audience: 'kids' | 'adults' | 'public';
  categoryKey: string;
  imageUrl: string;
  price: number;
  rating: number;
  reviewCount: number;
  stock: number;
};

const seededBooks: SeedBook[] = [
  {
    id: 'bakames-gift',
    title: "Bakame's Gift",
    description: 'Playful, imaginative storytelling for curious young readers.',
    author: 'Allain Samuel Giraneza',
    audience: 'kids',
    categoryKey: 'products.categories.children',
    imageUrl: '/kids/animation-story-guide.png',
    price: 12.5,
    rating: 4.8,
    reviewCount: 145,
    stock: 38,
  },
  {
    id: 'mr-bee-and-mr-mosquito',
    title: 'Mr. Bee and Mr. Mosquito',
    description: 'Fun animal characters and friendship lessons for children.',
    author: 'Jean Confiance Nsengiyumva',
    audience: 'kids',
    categoryKey: 'products.categories.children',
    imageUrl: '/kids/animation-kids-stack.png',
    price: 10.9,
    rating: 4.7,
    reviewCount: 121,
    stock: 42,
  },
  {
    id: 'akaleza-goes-into-space',
    title: 'Akaleza Goes Into Space',
    description: 'Adventure with science themes and bold dreams.',
    author: 'Mutesi Gasana',
    audience: 'kids',
    categoryKey: 'products.categories.adventure',
    imageUrl: '/kids/animation-africa-story-1.png',
    price: 13.75,
    rating: 4.9,
    reviewCount: 167,
    stock: 36,
  },
  {
    id: 'rufigi-the-little-mouse',
    title: 'Rufigi the Little Mouse',
    description: 'Simple, child-friendly tale with gentle moral lessons.',
    author: 'Habimana Augustin',
    audience: 'kids',
    categoryKey: 'products.categories.children',
    imageUrl: '/kids/pngtree-happy-school-children.png',
    price: 9.5,
    rating: 4.6,
    reviewCount: 92,
    stock: 50,
  },
  {
    id: 'karame-magazine-children-edition',
    title: "Karame Magazine (Children's Edition)",
    description: 'Educational and entertaining content designed for kids.',
    author: 'Karame Editorial Team',
    audience: 'kids',
    categoryKey: 'products.categories.children',
    imageUrl: '/kids/208e2cdeefc8e7285abb9b4df111cb5f.jpg',
    price: 8.25,
    rating: 4.5,
    reviewCount: 76,
    stock: 60,
  },
  {
    id: 'shami-and-nana-covid-19',
    title: 'Shami and Nana Learn About COVID-19',
    description: 'Health awareness story written for children.',
    author: 'Otaala Johnson',
    audience: 'kids',
    categoryKey: 'products.categories.children',
    imageUrl: '/kids/479a5dfbf35e0b62ed2653333b939b9f.jpg',
    price: 11.25,
    rating: 4.7,
    reviewCount: 88,
    stock: 44,
  },
  {
    id: 'adventures-of-kiki-the-monkey',
    title: 'The Adventures of Kiki the Monkey',
    description: 'Fun jungle adventures for early readers.',
    author: 'Haapa Kids Studio',
    audience: 'kids',
    categoryKey: 'products.categories.adventure',
    imageUrl: '/kids/pngtree-3d-smiling-girl.png',
    price: 10.0,
    rating: 4.6,
    reviewCount: 73,
    stock: 49,
  },
  {
    id: 'learning-with-colors-and-shapes',
    title: 'Learning with Colors and Shapes',
    description: 'Interactive educational book for toddlers.',
    author: 'Haapa Kids Studio',
    audience: 'kids',
    categoryKey: 'products.categories.children',
    imageUrl: '/kids/4b0f02acb36a9729c1588bb4830745ce.jpg',
    price: 9.0,
    rating: 4.5,
    reviewCount: 64,
    stock: 66,
  },
  {
    id: 'kirazira-mu-rubyiruko',
    title: 'Kirazira mu Rubyiruko',
    description: 'Social themes and reflection for youth and adults.',
    author: 'Nshimiyimana Didier',
    audience: 'adults',
    categoryKey: 'products.categories.history',
    imageUrl: '/adults/0475b884dea4ea754858e1b3b9beed92.jpg',
    price: 16.25,
    rating: 4.8,
    reviewCount: 143,
    stock: 31,
  },
  {
    id: 'ubabariye-wagira-ubuzima',
    title: 'Ubabariye, Wagira Ubuzima',
    description: 'Inspirational reading for mature audiences.',
    author: 'Twagirumukiza Fidele',
    audience: 'adults',
    categoryKey: 'products.categories.poetry',
    imageUrl: '/adults/08c664959ddfee2c3279bb596480cc1b.jpg',
    price: 15.75,
    rating: 4.7,
    reviewCount: 136,
    stock: 28,
  },
  {
    id: 'gusenga-si-ugushyenga',
    title: 'Gusenga si Ugushyenga',
    description: 'Faith and reflection for adult readers.',
    author: 'Twagirumukiza Fidele',
    audience: 'adults',
    categoryKey: 'products.categories.poetry',
    imageUrl: '/adults/12af55e5c94cef08b227174439e8423e.jpg',
    price: 14.4,
    rating: 4.6,
    reviewCount: 98,
    stock: 26,
  },
  {
    id: 'urukundo-nanze',
    title: 'Urukundo Nanze',
    description: 'Romance and relationships from a mature lens.',
    author: 'Joselyne Nzisabira',
    audience: 'adults',
    categoryKey: 'products.categories.poetry',
    imageUrl: '/adults/1706c8999736db7fb1b18ca3b8ff51dc.jpg',
    price: 15.2,
    rating: 4.7,
    reviewCount: 114,
    stock: 33,
  },
  {
    id: 'children-of-a-1000-hills-genesis',
    title: 'The Children of a 1000 Hills - Genesis',
    description: 'Historical and cultural narrative for adult readers.',
    author: 'Imanzi Creations',
    audience: 'adults',
    categoryKey: 'products.categories.history',
    imageUrl: '/adults/1d5b21b172d91fe5bf1c2169d7752eb5.jpg',
    price: 17.35,
    rating: 4.9,
    reviewCount: 162,
    stock: 24,
  },
  {
    id: 'nyiragitwa-daughter-of-sacyega',
    title: 'Nyiragitwa: Daughter of Sacyega',
    description: 'Rwandan heritage story with rich historical depth.',
    author: 'Mudacumura Publishing House',
    audience: 'adults',
    categoryKey: 'products.categories.history',
    imageUrl: '/adults/267316beede9027e5cd59174cf997ef2.jpg',
    price: 18.0,
    rating: 4.8,
    reviewCount: 151,
    stock: 27,
  },
  {
    id: 'business-growth-in-africa',
    title: 'Business Growth in Africa',
    description: 'Modern entrepreneurship insights and case studies.',
    author: 'Haapa Business Desk',
    audience: 'adults',
    categoryKey: 'products.categories.business',
    imageUrl: '/adults/7dec7a1b0e5fcf31e69d8a5771013a66.jpg',
    price: 19.5,
    rating: 4.7,
    reviewCount: 132,
    stock: 22,
  },
  {
    id: 'voices-of-the-hills',
    title: 'Voices of the Hills',
    description: 'Contemporary Rwandan literature anthology.',
    author: 'Haapa Literary Circle',
    audience: 'adults',
    categoryKey: 'products.categories.poetry',
    imageUrl: '/adults/bad3ff1f204030acc09d5ec7a41b60da.jpg',
    price: 16.85,
    rating: 4.6,
    reviewCount: 104,
    stock: 30,
  },
  {
    id: 'imagine-we-publishers-mission-booklet',
    title: "Imagine We Publishers' Mission Booklet",
    description: 'Promoting Rwandan authors, literacy programs, and community impact.',
    author: 'Imagine We Publishers',
    audience: 'public',
    categoryKey: 'products.categories.history',
    imageUrl: '/public/wallpaper for homepage.png',
    price: 6.0,
    rating: 4.5,
    reviewCount: 82,
    stock: 75,
  },
  {
    id: 'featured-kids-title-bakames-gift',
    title: "Featured Kids' Title: Bakame's Gift",
    description: 'Inclusive public selection featuring a standout children story.',
    author: 'Allain Samuel Giraneza',
    audience: 'public',
    categoryKey: 'products.categories.children',
    imageUrl: '/public/4931fa263e7334f061c7ca6b02478374.jpg',
    price: 12.0,
    rating: 4.8,
    reviewCount: 95,
    stock: 47,
  },
  {
    id: 'featured-adult-title-children-of-a-1000-hills',
    title: "Featured Adult Title: The Children of a 1000 Hills - Genesis",
    description: 'Public highlight that introduces cultural depth and history.',
    author: 'Imanzi Creations',
    audience: 'public',
    categoryKey: 'products.categories.history',
    imageUrl: '/public/512b25e3b639121fad93b32c384faf1c.jpg',
    price: 17.0,
    rating: 4.9,
    reviewCount: 109,
    stock: 29,
  },
  {
    id: 'community-reads-collection',
    title: 'Community Reads Collection',
    description: 'Curated mix of popular titles across age groups.',
    author: 'Haapa Community Team',
    audience: 'public',
    categoryKey: 'products.categories.adventure',
    imageUrl: '/public/54e606c2762cb65eb5c3023ae1f7f191.jpg',
    price: 11.75,
    rating: 4.6,
    reviewCount: 87,
    stock: 58,
  },
];

const POD_READY_BOOK_IDS = new Set([
  'bakames-gift',
  'mr-bee-and-mr-mosquito',
  'children-of-a-1000-hills-genesis',
  'nyiragitwa-daughter-of-sacyega',
  'business-growth-in-africa',
  'voices-of-the-hills',
  'imagine-we-publishers-mission-booklet',
  'featured-adult-title-children-of-a-1000-hills',
]);

const buildReviews = (book: SeedBook) => [
  {
    author: 'Amina',
    rating: Math.min(5, Number((book.rating - 0.1).toFixed(1))),
    commentKey: `${book.title} keeps readers engaged from the first page.`,
  },
  {
    author: 'Brian',
    rating: book.rating,
    commentKey: `Great work by ${book.author}.`,
  },
  {
    author: 'Chantal',
    rating: Math.min(5, Number((book.rating + 0.1).toFixed(1))),
    commentKey: 'Recommended for classroom and home libraries.',
  },
];

export const productCatalog: Product[] = seededBooks.map((book) => ({
  id: book.id,
  nameKey: book.title,
  descriptionKey: `${book.description} Author: ${book.author}.`,
  author: book.author,
  authorName: book.author,
  categoryKey: book.categoryKey,
  audience: book.audience,
  mediaType: 'book',
  price: book.price,
  printPrice: POD_READY_BOOK_IDS.has(book.id) ? Number((book.price * 1.55).toFixed(2)) : undefined,
  imageUrl: book.imageUrl,
  isPODAvailable: POD_READY_BOOK_IDS.has(book.id),
  rating: book.rating,
  reviewCount: book.reviewCount,
  stock: book.stock,
  reviews: buildReviews(book),
}));
